<template>
    <div class="carousel-container">
        <div class="carousel-content">
            <transition name="fade" mode="out-in">
                <img 
                    v-if="images.length > 0"
                    :src="images[current]" 
                    :key="current" 
                    alt="Image Carousel" 
                    class="carousel-image"
                    @click="openModal(images[current])"
                />
            </transition>
            <button v-if="images.length > 1" @click="prev" class="carousel-btn prev">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
            </button>
            <button v-if="images.length > 1" @click="next" class="carousel-btn next">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"/></svg>
            </button>
        </div>
        <div v-if="images.length > 1" class="carousel-dots">
            <span
                v-for="(_, index) in images"
                :key="index"
                class="dot"
                :class="{ active: current === index }"
                @click="goTo(index)"
            ></span>
        </div>

        <!-- Modale pour le zoom -->
        <div v-if="isModalVisible" class="modal-overlay" @click="closeModal">
            <span class="modal-close" @click.stop="closeModal">&times;</span>
            <img :src="zoomedImage" alt="Image zoomée" class="modal-content" @click.stop>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        images: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            current: 0,
            isModalVisible: false,
            zoomedImage: ''
        }
    },
    methods: {
        next() {
            if (this.images.length === 0) return;
            this.current = (this.current + 1) % this.images.length;
        },
        prev() {
            if (this.images.length === 0) return;
            this.current = (this.current - 1 + this.images.length) % this.images.length;
        },
        goTo(index) {
            this.current = index;
        },
        openModal(imageSrc) {
            if (!imageSrc) return;
            this.zoomedImage = imageSrc;
            this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
            this.zoomedImage = '';
        }
    }
}
</script>

<style scoped>
.carousel-container {
    width: 100%;
    max-width: 600px;
    margin: auto;
    position: relative;
}

.carousel-content {
    position: relative;
    overflow: hidden;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    background-color: #f0f0f0; /* Fallback color */
}

.carousel-image {
    width: 100%;
    display: block;
    height: 350px; /* Hauteur ajustable */
    object-fit: cover;
    cursor: zoom-in;
}

/* Style des boutons de navigation */
.carousel-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.4);
    color: white;
    border: none;
    border-radius: 50%;
    width: 44px;
    height: 44px;
    cursor: pointer;
    transition: background-color 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
}

.carousel-btn:hover {
    background-color: rgba(0, 0, 0, 0.7);
}

.carousel-btn.prev {
    left: 10px;
}

.carousel-btn.next {
    right: 10px;
}

/* Style des puces de navigation */
.carousel-dots {
    text-align: center;
    padding: 15px 0;
}

.dot {
    cursor: pointer;
    height: 12px;
    width: 12px;
    margin: 0 5px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    transition: background-color 0.3s ease;
}

.dot.active {
    background-color: #717171;
}

/* Transition de fondu */
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.4s ease;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}

/* Styles pour la modale de zoom */
.modal-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0,0,0,0.85);
}

.modal-content {
  display: block;
  max-width: 90vw;
  max-height: 90vh;
  border-radius: 8px;
}

.modal-close {
  position: absolute;
  top: 20px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  cursor: pointer;
  transition: color 0.3s;
  z-index: 1001;
}

.modal-close:hover {
    color: #bbb;
}
</style>